import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import DmsLocations from "../../compenents/Integration/DmsSetup/DmsLocations";
import DmsProducts from "../../compenents/Integration/DmsSetup/DmsProducts";
import DmsProductType from "../../compenents/Integration/DmsSetup/DmsProductType";
import InitializeShopify from "../../compenents/Integration/DmsSetup/InitializeShopify";
import MatchingProducts from "../../compenents/Integration/DmsSetup/MatchingProducts";
import MismatchProducts from "../../compenents/Integration/DmsSetup/MismatchProducts";
import ShopifySettings from "../../compenents/Integration/DmsSetup/ShopifySettings";
import { useGetDealerLocationsMutation } from "../../redux/reducer/features/Integration/DmsSetupSlice";
import { AppState } from "../../redux/reducer/rootReducer";
import DmsManufacturers from "../../compenents/Integration/DmsSetup/DmsManufacturers";
import { useGetManufacturersQuery } from "../../redux/reducer/features/Product/productSlice";

interface DmsSetupProps {}

const DmsSetup: React.FunctionComponent<DmsSetupProps> = (props) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const everestDmsDealerId = useSelector(
    (state: AppState) => state.authReducer.everestDmsDealerId
  );
  const catalogManufacturers = useGetManufacturersQuery();
  const [dmsLocationMutation, dmsLocationMutationResult] =
    useGetDealerLocationsMutation();
  useEffect(() => {
    dmsLocationMutation({
      everestDmsDealerId: everestDmsDealerId ?? "",
    });
  }, []);
  var arg: void;

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const steps = [
    {
      label: "Shopify Settings",
      component: (
        <ShopifySettings handleBack={handleBack} handleNext={handleNext} />
      ),
      isRequired: true,
    },
    {
      label: "Locations",
      component: (
        <DmsLocations
          locations={dmsLocationMutationResult?.data?.entityList ?? []}
          handleBack={handleBack}
          handleNext={handleNext}
        />
      ),
      isRequired: true,
    },
    {
      label: "Manufacturers",
      component: (
        <DmsManufacturers
          handleBack={handleBack}
          handleNext={handleNext}
          catalogManufacturers={
            catalogManufacturers.data && catalogManufacturers.data.entityList
              ? catalogManufacturers.data.entityList
              : []
          }
        />
      ),
      isRequired: true,
    },
    {
      label: "Product Type",
      component: (
        <DmsProductType isReInitiateRequest={false} handleBack={handleBack} handleNext={handleNext} />
      ),
      isRequired: true,
    },
    {
      label: "Fetch DMS Data",
      component: (
        <DmsProducts handleBack={handleBack} handleNext={handleNext} />
      ),
      isRequired: true,
    },
    {
      label: "Matching Products",
      component: (
        <MatchingProducts
          handleBack={handleBack}
          handleNext={handleNext}
          locations={dmsLocationMutationResult.data?.entityList ?? []}
        />
      ),
      isRequired: true,
    },
    {
      label: "Not Matching Products",
      component: (
        <MismatchProducts handleBack={handleBack} handleNext={handleNext} />
      ),
    },
    {
      label: "Shopify Initialization",
      component: (
        <InitializeShopify
          handleBack={handleBack}
          locations={dmsLocationMutationResult.data?.entityList ?? []}
        />
      ),
      isRequired: true,
    },
  ];

  return (
    <Container maxWidth={false}>
      <Card>
        <CardContent>
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={activeStep}>
              {steps.map((item, index) => {
                const stepProps: { completed?: boolean } = {};
                const labelProps: {
                  optional?: React.ReactNode;
                } = {};

                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={item.label} {...stepProps} disabled>
                    <StepLabel {...labelProps}>{item.label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset}>Reset</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Typography sx={{ mt: 1, mb: 0 }}>
                  {steps[activeStep].component}
                </Typography>
              </React.Fragment>
            )}
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default DmsSetup;
